const keysPressed = {};
const keydownHandler = event => {
  keysPressed[event.key] = true;
};
const keyupHandler = event => {
  keysPressed[event.key] = false;
};
const initKeysPressed = () => {
  document.addEventListener('keydown', keydownHandler);
  document.addEventListener('keyup', keyupHandler);
};

initKeysPressed();

export { keysPressed };
